import { useState, useEffect } from 'react';
import { SelectLogmar, AcuityResults, KaysOptotypesTest } from '..';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import ExamEyeSetup from '../exams/ExamEyeSetup';
import { ExamBody, useExamStep } from '../exams/common';
import { examTitle } from '../exams/examCatalog';

const KaysOptotypes = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const postMessage = usePostMessage();
  const [step, setStep] = useState('eyeSetup');
  useExamStep(testData.testKey, step);
  const testTitle = examTitle(testData.testKey);

  useEffect(() => {
    switch (step) {
      case 'eyeSetup':
        setTitle(testTitle);
        break;
      case 'rightEyeSetup':
        setTitle(`${testTitle} - Right Eye`);
        break;
      case 'leftEyeSetup':
        setTitle(`${testTitle} - Left Eye`);
        if (testData.testRightEye) updateTestData({ testInProgress: true });
        break;
      case 'bothEyesSetup':
        setTitle(`${testTitle} - Binocular`);
        break;
      case 'rightEyeTest':
        setTitle(`${testTitle} - Right Eye`);
        break;
      case 'leftEyeTest':
        setTitle(`${testTitle} - Left Eye`);
        break;
      case 'bothEyesTest':
        setTitle(`${testTitle} - Binocular`);
        break;
      case 'results':
        setTitle(`${testTitle} Results`);
        break;
      default:
        break;
    }
  }, [setTitle, step, updateTestData, testData.testRightEye, testTitle]);

  const updateStep = (selectedStep) => {
    if (selectedStep === 'results') {
      postMessage({ type: 'endOfTest' });
    }
    if (selectedStep.endsWith('Setup')) postMessage({ type: 'holding' });
    setStep(selectedStep);
  };

  const renderSwitch = () => {
    switch (step) {
      case 'eyeSetup':
        return <ExamEyeSetup updateStep={updateStep} selectCrowding selectOptotypeAmount />;
      case 'bothEyesSetup':
      case 'rightEyeSetup':
      case 'leftEyeSetup':
        return <SelectLogmar eyeTested={step.split('S')[0]} updateStep={updateStep} />;
      case 'rightEyeTest':
      case 'leftEyeTest':
      case 'bothEyesTest':
        return <KaysOptotypesTest eyeTested={step.split('T')[0]} updateStep={updateStep} />;
      case 'results':
        return <AcuityResults localResults={testData} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return <ExamBody>{renderSwitch()}</ExamBody>;
};

export default KaysOptotypes;
